<template>
  <v-row align="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="col-md-12 home-tabs-body ">
      <PageTitle :title="'Project Info'" class="pt-5 mx-3"></PageTitle>
      <ProjectDetails></ProjectDetails>
    </div>
  </v-row>
</template>

<script>

import ProjectDetails from "@/components/projects/ProjectDetails";
import { createNamespacedHelpers } from "vuex";
import PageTitle from "@/components/shared/PageTitle";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Projects",
  components: {
    ProjectDetails,
    PageTitle
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
    window.scrollTo(0, 0);
  },

  watch: {

  },

  methods: {

  },

};
</script>

  